import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ErrorAccessor } from '../state/ErrorAccessor';
import { reportGetResolvedErrorBi } from './reportGetResolvedErrorBi';
import { fallbackMessage } from '../fallbackMessage';
export class ErrorHandlerV2 {
  constructor(_errorHandler) {
    _defineProperty(this, "errorHandler", void 0);
    _defineProperty(this, "withErrorHandler", async (fn, errorCodesMap) => {
      return this.errorHandler.withErrorHandler(fn, {
        errorCodesMap: {
          validationError: errorCodesMap,
          statusCodeError: errorCodesMap,
          applicationError: Object.entries(errorCodesMap).reduce((acc, _ref) => {
            let [key, value] = _ref;
            if (value) {
              acc[key] = (_, error) => value(error);
            }
            return acc;
          }, {}),
          serverError: errorCodesMap.serverError
        }
      });
    });
    _defineProperty(this, "getResolvedError", error => {
      const {
        errorHandler
      } = this;
      const {
        errorMonitor
      } = errorHandler;
      try {
        const errorAccessor = new ErrorAccessor({
          error
        });
        const {
          httpError,
          error: e
        } = errorAccessor;
        const errorResolution = errorHandler._resolveError(errorAccessor);
        const resolvedError = e == null ? void 0 : e._errorHandlerResolvedError;
        const message = (resolvedError == null ? void 0 : resolvedError.message) ?? fallbackMessage;
        const action = resolvedError == null ? void 0 : resolvedError.action;
        const requestId = (resolvedError == null ? void 0 : resolvedError.requestId) ?? (httpError == null ? void 0 : httpError.requestId);
        reportGetResolvedErrorBi(errorHandler, {
          message,
          action,
          errorAccessor,
          errorResolution
        });
        return {
          message,
          action,
          requestId,
          ...resolvedError
        };
      } catch (e) {
        console.error(e);
        errorMonitor.captureException(e);
        throw e;
      }
    });
    _defineProperty(this, "showError", (error, props) => {
      this.errorHandler.showError(error, props);
    });
    _defineProperty(this, "reportRetryAttempt", error => {
      this.errorHandler.reportRetryAttempt(error);
    });
    _defineProperty(this, "handleError", (error, options) => {
      this.errorHandler.handleError(error, options);
    });
    this.errorHandler = _errorHandler;
  }
}
//# sourceMappingURL=ErrorHandlerV2.js.map